import { useContext, useEffect, useRef } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';

export default function AutoplayButton({ className, children }) {
  const buttonRef = useRef();
  const { autoplayRunning, toggleAutoplay, stopAutoplay } = useContext(CatalogContext);

  useEffect(() => {
    const handleClick = e => {
      if (e.target.closest('.autoplay-button') !== buttonRef.current) {
        stopAutoplay();
      }
    };

    const handleKeydown = e => {
      stopAutoplay();
    };

    window.addEventListener('click', handleClick);
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <button
      ref={buttonRef}
      className={`autoplay-button ${className}`}
      data-playing-state={autoplayRunning ? 'playing' : 'paused'}
      onClick={toggleAutoplay}
    >
      {children}
    </button>
  );
}
